"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require("react-bootstrap");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotFound = function NotFound(props) {
  var bsStyle = props.bsStyle,
      className = props.className,
      message = props.message,
      title = props.title;

  return _react2.default.createElement(
    "div",
    { className: (0, _classnames2.default)("erg-components-NotFound", className) },
    _react2.default.createElement(
      _reactBootstrap.Alert,
      { bsStyle: bsStyle },
      _react2.default.createElement(
        "h4",
        null,
        title
      ),
      _react2.default.createElement(
        "p",
        null,
        message
      )
    )
  );
};

NotFound.displayName = "NotFound";

NotFound.propTypes = {
  bsStyle: _propTypes2.default.oneOf(["danger", "info", "success", "warning"]),
  className: _propTypes2.default.string,
  message: _propTypes2.default.node,
  title: _propTypes2.default.node
};

NotFound.defaultProps = {
  bsStyle: "danger",
  message: "Page not found.",
  title: "404 / Not Found"
};

exports.default = NotFound;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-components-react/lib/NotFound.js
 ** module id = 786
 ** module chunks = 0
 **/